import React from 'react';

export const TextWithHighlightedMatches = ({ text, searchValue }: { text: string; searchValue?: string }) => {
  if (!searchValue) {
    return <>{text}</>;
  }
  const matches = text.match(new RegExp(searchValue, 'gi'));
  const splitByHighlights = text.split(new RegExp(searchValue, 'gi'));

  return (
    <>
      {splitByHighlights.map((part, index) => (
        <React.Fragment key={index}>
          {part}
          {matches?.[index] && <b>{matches?.[index]}</b>}
        </React.Fragment>
      ))}
    </>
  );
};
